import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Box, Typography, List, ListItem, ListItemText, Paper, Grid } from "@mui/material";
import L from "leaflet";

const customIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  iconSize: [30, 30],
});

const countriesData = [
  { country: "India", visits: 647, flag: "🇮🇳", color: "rgba(0, 0, 255, 0.8)" },
  { country: "United States", visits: 435, flag: "🇺🇸", color: "rgba(0, 255, 0, 0.6)" },
  { country: "Vietnam", visits: 287, flag: "🇻🇳", color: "rgba(255, 0, 0, 0.6)" },
  { country: "Australia", visits: 432, flag: "🇦🇺", color: "rgba(255, 165, 0, 0.6)" },
  { country: "Angola", visits: 345, flag: "🇦🇴", color: "rgba(0, 128, 0, 0.6)" },
  { country: "Russia", visits: 500, flag: "🇷🇺", color: "rgba(255, 0, 0, 0.8)" },
  { country: "Brazil", visits: 678, flag: "🇧🇷", color: "rgba(0, 128, 255, 0.8)" },
];

const WorldMapWithColoredRegions = () => {
  const [geoData, setGeoData] = useState(null);

  useEffect(() => {
    const fetchGeoJSON = async () => {
      const response = await fetch(
        "https://raw.githubusercontent.com/johan/world.geo.json/master/countries.geo.json"
      );
      const data = await response.json();
      setGeoData(data);
    };
    fetchGeoJSON();
  }, []);

  const styleFeature = (feature) => {
    const countryName = feature.properties.name;
    const countryData = countriesData.find(
      (c) => c.country.toLowerCase() === countryName.toLowerCase()
    );

    return {
      fillColor: countryData ? countryData.color : "rgba(169, 169, 169, 0.4)",
      weight: 1,
      opacity: 1,
      color: "white",
      fillOpacity: 0.8,
    };
  };

  return (
    <Box sx={{ height: "30vh", p: 2 }}>
      <Grid container spacing={2} sx={{ height: "50%" }}>
        <Grid item xs={8}>
          <MapContainer
            style={{ height: "100%", borderRadius: "8px", overflow: "hidden" }}
            center={[20, 0]}
            zoom={2}
            scrollWheelZoom={false}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {geoData && <GeoJSON data={geoData} style={styleFeature} />}
            <Marker position={[20.5937, 78.9629]} icon={customIcon}>
              <Popup>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  India
                </Typography>
                <Typography variant="body2">Visits: 647</Typography>
              </Popup>
            </Marker>
          </MapContainer>
        </Grid>
        <Grid item xs={4}>
          <Paper
            elevation={3}
            sx={{
              height: "100%",
              borderRadius: "12px",
              p: 3,
              overflowY: "auto",
              maxHeight: "90vh",
            }}
          >
            <Typography variant="h6" sx={{ textAlign: "center", fontWeight: "bold", mb: 2 }}>
              Top Countries
            </Typography>
            <Typography variant="subtitle1" sx={{ textAlign: "center", color: "#757575", mb: 2 }}>
              Total Visits: 9587
            </Typography>
            <List>
              {countriesData.map((country, index) => (
                <ListItem
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #eee",
                    mb: 1,
                    pb: 1,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: "bold" }}
                  >
                    <span style={{ fontSize: "24px" }}>{country.flag}</span>
                    {country.country}
                  </Typography>
                  <ListItemText
                    primary={`${country.visits} visits`}
                    primaryTypographyProps={{ textAlign: "right" }}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WorldMapWithColoredRegions;
